import { render, staticRenderFns } from "./showTotalAvatar.vue?vue&type=template&id=0ddb528e&"
import script from "./showTotalAvatar.vue?vue&type=script&lang=js&"
export * from "./showTotalAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports